import React from 'react';
import { YellowWarningIcon } from 'assests/GmsIcons';

type ConfirmDialogProps = {
    title: string;
    message: string;
    confirmText: string;
    cancelText: string;
    onClose: () => void;
    onConfirm: () => void;
}

const ConfirmDialog = ({ title, message, confirmText, cancelText, onClose, onConfirm }: ConfirmDialogProps) => {
    return (
        <div className="tw-fixed tw-inset-0 tw-flex tw-items-center tw-justify-center tw-bg-gray-800 tw-bg-opacity-50 tw-z-50">
            <div className="tw-bg-white tw-rounded tw-shadow-md tw-w-[457px] tw-flex tw-flex-col">
                <div className="tw-flex tw-justify-between tw-items-center">
                    <h2 className="tw-text-sm tw-font-semibold tw-my-3 tw-px-3">{title}</h2>
                </div>

                <div className="tw-w-full tw-border-t tw-border-[#dfe0e6]"></div>

                <div className="tw-m-4 tw-p-2.5 tw-bg-[#fffae6] tw-rounded tw-border tw-border-[#ffc400] tw-flex tw-items-start tw-gap-2.5">
                    <div className="tw-flex-shrink-0"><YellowWarningIcon /></div>
                    <div className="tw-text-black tw-text-sm tw-leading-tight">{message}</div>
                </div>

                <div className="tw-px-3 tw-py-4 tw-flex tw-gap-2 tw-justify-end tw-mt-auto">
                    <button onClick={onClose} className="button-outlined hover:tw-bg-gray-100 tw-flex">{cancelText}</button>
                    <button
                        className="tw-px-2 tw-py-2 tw-justify-center tw-items-center tw-gap-2.5 tw-rounded-md tw-inline-flex tw-text-white hover:tw-bg-red-500 tw-bg-red-600"
                        onClick={onConfirm}
                    >
                        {confirmText}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default ConfirmDialog;